import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get, isEmpty } from 'lodash';
import { GetRegion } from 'constants.js';
import { showModal, removeModal } from 'actions/response';
import Metrics from 'services/metrics';
import {
  onRentHistory,
  onRentHistoryInfo,
} from 'action-creators/payway/rentHistory';
import { actions as modifyActions } from 'action-creators/device/modify';
import { actions as detachActions } from 'action-creators/device/detach';
import PanelClaro from 'newComponents/PanelClaro/PanelClaro';
import Loader from 'components/Loader';
import {
  getPayload,
  getLoading,
  getRentHistoryIsEmpty,
} from 'selectors/payway/rentHistory';
import RentHistory from './rentHistory';
import HeaderSection from './components/HeaderSection';
import EmptySection from './components/EmptySection';
import PaginatorSection from './components/PaginatorSection';
import { getLabels, MAX_ITEMS_BY_PAGE } from './constants';
import { useNavigate } from 'react-router-dom';
function HistorySection({
  emptyHistory,
  payload,
  loading,
  onShowModal,
  onRemoveModal,
  handleRentHistory,
  handleRentHistoryInfo,
  handleModifyDevice,
  handleDetachDevice,
  handleDetachDevices,
  translations
}) {
  const navigate = useNavigate()
  const labels = getLabels(translations);
  const [items, setItems] = useState([]);
  const [pages, setPages] = useState(1);
  const [page, setPage] = useState(0);

  useEffect(() => {
    if (!isEmpty(payload) && payload.length > 0) setItems(payload);
    else handleRentHistory(MAX_ITEMS_BY_PAGE);
  }, []);

  useEffect(
    () => {
      if (payload.length) {
        setPages(payload.length);
        setItems(payload);
      }
    },
    [payload],
  );

  const pageIsLoaded = numberPage => get(items[numberPage], '0.apply', false);

  const handleChangePage = number => {
    const newPage = page + number;
    setPage(newPage);
    if (!pageIsLoaded(newPage)) handleRentHistoryInfo(items, newPage);
  };

  const handleRedirect = (e, label = 'Ver') => {
    const url = `/${GetRegion()}/vcard/${e.title_uri}/${e.id}`;
    Metrics.newEvent({
      eventCategory: 'Historial',
      eventAction: e.title,
      eventLabel: label,
    });
    navigate(url);
  };

  const handleModifyDeviceByContent = data => {
    const infoDevice = data;
    infoDevice.page = page;
    return handleModifyDevice(infoDevice);
  };

  const handleDetachDeviceByContent = data => {
    const infoDevice = data;
    infoDevice.page = page;
    return handleDetachDevice(infoDevice);
  };

  const handleDetachDevicesByContent = data => {
    const infoDevice = data;
    infoDevice.map(e => {
      e.page = page;
      return e;
    });
    return handleDetachDevices(infoDevice);
  };

  return (
    <PanelClaro sectionName="micuentahistorial" className="row">
      <HeaderSection label={labels} />
      {loading && (
        <div className="row loading-section">
          <Loader />
        </div>
      )}
      {!emptyHistory && !loading && (
        <>
          {items[page] &&
            items[page].map((e, i) => {
              const className = i % 2 === 0 ? 'impar' : '';
              const active =
                parseInt(get(e, 'purchase.data.response.playButton.visible', '0'), 10) === 1;
              const download =
                parseInt(get(e, 'purchase.data.response.downloadButton.visible', '0'), 10) ===
                1;
              return (
                <RentHistory
                  index={i}
                  key={`key-${e.purchase_id}`}
                  active={active}
                  download={download}
                  item={e}
                  page={page + 1}
                  total={pages}
                  labels={labels}
                  className={className}
                  onChangePage={handleChangePage}
                  onRedirect={handleRedirect}
                  onModifyDevice={handleModifyDeviceByContent}
                  onDetachDevice={handleDetachDeviceByContent}
                  onDetachDevices={handleDetachDevicesByContent}
                  onShowModal={onShowModal}
                  onRemoveModal={onRemoveModal}
                />
              );
            })}
        </>
      )}
      {!emptyHistory && (
        <PaginatorSection
          label={labels}
          disabled={loading}
          onClick={handleChangePage}
          page={page + 1}
          total={pages}
        />
      )}
      {emptyHistory && <EmptySection label={labels} />}
    </PanelClaro>
  );
}

HistorySection.propTypes = {
  //   user: PropTypes.object,
  loading: PropTypes.bool,
  emptyHistory: PropTypes.bool,
  payload: PropTypes.array,
  onShowModal: PropTypes.func.isRequired,
  onRemoveModal: PropTypes.func.isRequired,
  handleRentHistory: PropTypes.func.isRequired,
  handleRentHistoryInfo: PropTypes.func.isRequired,
  handleModifyDevice: PropTypes.func.isRequired,
  handleDetachDevice: PropTypes.func.isRequired,
  handleDetachDevices: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  loading: getLoading(state),
  emptyHistory: getRentHistoryIsEmpty(state),
  payload: getPayload(state),
  translations: state?.translations
});

const mapDispatchToProps = dispatch => ({
  onShowModal(payload) {
    dispatch(showModal(payload));
  },
  onRemoveModal(payload) {
    dispatch(removeModal(payload));
  },
  handleRentHistory(maxItems) {
    dispatch(onRentHistory(maxItems));
  },
  handleRentHistoryInfo(payload, page) {
    dispatch(onRentHistoryInfo(payload, page));
  },
  handleModifyDevice(payload, page) {
    dispatch(modifyActions.modifyDeviceByContent(payload, page));
  },
  handleDetachDevice(payload, page) {
    dispatch(detachActions.detachDeviceByPurchaseSuccess(payload, page));
  },
  handleDetachDevices(payload, page) {
    dispatch(detachActions.detachDevicesByPurchaseSuccess(payload, page));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HistorySection);
